import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import * as M from "materialize-css/dist/js/materialize";
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AntEnvService, DataService } from '../../_services';
import { IfStmt } from '@angular/compiler';
import { HttpEvent, HttpEventType } from '@angular/common/http';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  @ViewChild('myInput') myInputVariable: ElementRef;
  client = '';
  pageData = {
    viewMode: 'LIST',
    ActionMode: 'NEW',
    zones: [],
    sensorName: '',
    sensorId: '',
    areaName: '',
    areaRemark: '',
    sensorInFlow: -1,
    sensorOutFlow: -1,
    inTune: 100,
    outTune: 100
  };
  rootArea:any;
  tArea:any;
  areas = [];
  zoneSelected:any;
  sensorSelected:any;
  isRoot:any = true;
  file: any;
  ImageBaseData: string | ArrayBuffer;
  imgUpload: any = false;
  progress: number = 0;
  isUpload: any = false;
  imgPath: any;
  tmpRootImgPath: any;

  constructor(
    private router: Router,
    private changeDetector : ChangeDetectorRef,
    public svcData: DataService,
    public svcAntEnv: AntEnvService
  ) { }

  ngOnInit() {
    //this.client = environment.client;
    this.svcAntEnv.load().subscribe(res=>{
      if(res.client != null){
          this.client = res.client;
          //console.log(this.client);
      }
    });
    //this.areaListLoad('0');
    this.svcData.areaList('0').subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      if(res.data.length<1){
        this.showAlert('No Area found!');
        return;
      }
      //this.areaSelect(this.pageData.areas[0]);
      this.tArea = res.data[0];
      //this.areaInfoLoad({area: this.tArea});
      this.areaInfoLoad(this.tArea, true);
      this.getFPImage(this.tArea);
    });

    this.initDDL();
  }

  initDDL(){
    var elems = document.querySelectorAll('.dropdown-trigger');
    M.Dropdown.init(elems, {});
    setTimeout(function(){
      M.FormSelect.init(document.querySelectorAll('select'), {classes:''});
    }, 3000);
  }
  ngAfterViewInit(){
    //console.log('this is ngAfterViewInit');
    this.svcData.usageAdd('{"userId":"'+JSON.parse(localStorage.getItem("currentUser")).userId+'","code":"SETTINGS-VIEW","actionCode":"SETTINGS-VIEW"}').subscribe();
  }
  onFileChange(event: any){
    this.file = null;
    let me = this;
    this.file = event.target.files[0];
    this.imgUpload = true;
    let reader = new FileReader();
    reader.readAsDataURL(this.file);
    reader.onload = function () {
      //console.log(reader.result);
      me.ImageBaseData=reader.result;
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }
  imgCancel(event: any){
    this.imgUpload = false;
    this.file = null;
    this.ImageBaseData = '';
  }
  imgUpdate(events: any){
    var _arg = {
      areaId:this.tArea.areaId,
      imgB64: this.ImageBaseData.toString()
    }
    this.svcData.updateFPImage(_arg).subscribe(res=>{
      this.tArea.imgB64 = _arg.imgB64;
      this.imgUpload = false;
      this.file = null;
      this.showAlert('Image upload successful!')
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      
    });
      
      // switch (event.type) {
      //   case HttpEventType.Sent:
      //     console.log('Request has been made!');
      //     break;
      //   case HttpEventType.ResponseHeader:
      //     console.log('Response header has been received!');
      //     break;
      //   case HttpEventType.UploadProgress:
      //     var eventTotal = event.total ? event.total : 0;
      //     this.progress = Math.round(event.loaded / eventTotal * 100);
      //     console.log(`Uploaded! ${this.progress}%`);
      //     break;
      //   case HttpEventType.Response:
      //     console.log('Image Upload Successfully!', event.body);
      //     // this.tArea.imgB64 = _arg.imgB64;
      //     // this.imgUpload = false;
      //     // this.file = null;
      //     setTimeout(() => {
      //       this.progress = 0;
      //     }, 1500);  
      // }
    
  }

  photoSelectFile(event: any){
    this.file = null;
    let me = this;
    this.file = event.target.files[0];
    if(this.file != null){
      this.isUpload = true;
    }
    let reader = new FileReader();
    reader.readAsDataURL(this.file);
    reader.onload = function () {
      me.ImageBaseData=reader.result;      
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  fpImgUpload(events: any){
    var _arg = {
      areaId:this.tArea.areaId,
      imgB64: this.ImageBaseData.toString()
    }
    this.svcData.uploadFPImage(_arg).subscribe(res=>{
      this.file = null;
      this.isUpload = false;
      this.myInputVariable.nativeElement.value = "";
      this.showAlert('Image upload successful!')
      this.getFPImage(this.tArea);
      if(res.status != 'OK'){
        this.showAlert(res.message);        
        return;
      }
      
    });    
  }
  areaForm(){
    this.pageData.viewMode = 'AREA-FORM';
    this.pageData.areaName = '';
    this.pageData.areaRemark = '';
    this.ImageBaseData = '';
    this.file = null;
    this.imgUpload = false;
  }
  areaFormCancel(){
    this.pageData.viewMode = 'LIST';
    this.ImageBaseData = '';
    this.file = null;
    this.imgUpload = false;
  }
  areaFormSave(){
    if(!this.pageData.areaName){
      this.showAlert('Area Name should not be empty!');
      return;
    }
    if(!this.pageData.areaRemark){
      this.showAlert('Remark should not be empty!');
      return;
    }
    if(!this.file){
      this.showAlert('Image file should not be empty!');
    }

    var _arg = {
      client: {clientId: this.tArea.client.clientId},
      parentArea: {areaId: this.tArea.areaId},
      areaName: this.pageData.areaName,
      remark: this.pageData.areaRemark,
      imgB64: this.ImageBaseData.toString()
    }
    this.svcData.areaAdd(_arg).subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.pageData.viewMode = 'LIST';
      this.areaInfoLoad(this.tArea, this.isRoot);
    });
  }
  areaConfigChange(arg){
    if(arg == 'area.occupancy'){
      this.svcData.configAdd(this.tArea.areaId, arg, this.tArea.isOccupancyArea?'1':'0').subscribe(res=>{
        if(res.status != 'OK'){
          this.showAlert(res.message);
          return;
        }
        this.showAlert('Occupancy config is updated!');
        this.areaInfoLoad(this.tArea, this.isRoot);
      });
    }
    else if(arg == 'area.standalone'){
      this.svcData.configAdd(this.tArea.areaId, arg, this.tArea.isStandaloneArea?'1':'0').subscribe(res=>{
        if(res.status != 'OK'){
          this.showAlert(res.message);
          return;
        }
        this.showAlert('Standalone config is updated!');
        this.areaInfoLoad(this.tArea, this.isRoot);
      });
    }
    // else if(arg == 'area.priority'){
    //   this.svcData.configAdd(this.tArea.areaId, arg, this.tArea.isPriority?'1':'0').subscribe(res=>{
    //     if(res.status != 'OK'){
    //       this.showAlert(res.message);
    //       return;
    //     }
    //     this.showAlert('Priority config is updated!');
    //     this.areaInfoLoad(this.tArea, this.isRoot);
    //   });
    // }
    else if(arg == 'area.enable.dwelltime'){
      this.svcData.configAdd(this.tArea.areaId, arg, this.tArea.isDwellTimeEnabled?'1':'0').subscribe(res=>{
        if(res.status != 'OK'){
          this.showAlert(res.message);
          return;
        }
        this.showAlert('Dwelltime config is updated!');
        this.areaInfoLoad(this.tArea, this.isRoot);
      });
    }
  }
  areaInfoLoad(arg:any, isRoot = false){ //arg: {area: any}
    this.svcData.areaDetail(arg.areaId).subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      //arg = res.data;
      arg.childAreas = res.data.childAreas;
      arg.sensors = res.data.sensors;
      arg.configs = res.data.configs;
      var cArea = this.tArea.childAreas;
      //console.log(isRoot);
      
      if(isRoot){
        //console.log(isRoot);
        this.rootArea = res.data;
        arg.childAreas.forEach(a => {
          this.areaInfoLoad(a, false);
        });
      }

      if(cArea){
        cArea.forEach((ca, i) => {
          this.svcData.getFPImage(ca).subscribe( res => {
            //console.log(res)
            this.tArea.childAreas[i].imgB64 = 'data:image/png;base64,'+res.data;
          })
        })
      }

      //console.log(arg.configs);
      arg.isOccupancyArea = arg.configs['area.occupancy'] == '1';
      arg.isStandaloneArea = arg.configs['area.standalone'] == '1';
      arg.isDwellTimeEnabled = arg.configs['area.enable.dwelltime'] == '1';
      arg.isPriority = arg.configs['area.priority'];

    });
    //this.areaListLoad(this.tArea.areaId);
  }
  areaListLoad(parentId){
    this.svcData.areaList(parentId).subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.areas = res.data;
      //console.log(this.areas);
      //this.areaSelect(this.pageData.areas[0]);
    });
  }
  areaView(arg){
    //console.log(arg);
    this.svcData.getFPImage(arg).subscribe( res => {
      this.imgPath = 'data:image/png;base64,'+res.data;
    })
    this.tArea = arg;
    //this.imgPath = arg.imgB64;
    this.initDDL();
    this.isRoot = false;
  }
  areaViewRoot(arg){  
    this.rootArea.isPriority = this.rootArea.configs['area.priority'] 
    if(this.tmpRootImgPath){
      this.imgPath = this.tmpRootImgPath;
    }
    this.areaView(this.rootArea);
    // this.tArea = arg;
    // this.initDDL();
    this.isRoot = true;
  }
  dataBind(){
    if(this.pageData.zones.length>0)
    this.zoneSelected = this.pageData.zones[0];
  }
  zoneSelect(arg){
    this.zoneSelected = arg;
  }
  sensorForm(){
    this.pageData.viewMode = 'SENSOR-FORM';
    this.pageData.sensorId = '';
    this.pageData.sensorName = '';
    this.pageData.ActionMode = 'NEW';
  }
    sensorEdit(arg){
    this.sensorSelected = arg;
    this.pageData.viewMode = 'SENSOR-FORM';
    this.pageData.sensorId = arg.sensorId;
    this.pageData.sensorName = arg.sensorName;
    this.pageData.sensorInFlow = arg.inFlow;
    this.pageData.sensorOutFlow = arg.outFlow;
    this.pageData.inTune = arg.inTune;
    this.pageData.outTune = arg.outTune;
    this.pageData.ActionMode = 'EDIT';
  }
  sensorFormCancel(){
    this.pageData.viewMode = 'LIST';
  }
  sensorFormSave(){
    if(!this.sensorFormValidate()) return;

    var _arg = {
      area: {areaId: this.tArea.areaId},
      sensorId: this.pageData.sensorId,
      sensorName: this.pageData.sensorName,
      inFlow: this.pageData.sensorInFlow,
      outFlow: this.pageData.sensorOutFlow,
      inTune: this.pageData.inTune,
      outTune: this.pageData.outTune
    }
    if(this.pageData.ActionMode == 'NEW'){
      this.svcData.sensorAdd(_arg).subscribe(res=>{
        if(res.status != 'OK'){
          this.showAlert(res.message);
          return;
        }
        this.showAlert('Sensor information is added!');
        this.pageData.viewMode = 'LIST';
        this.areaInfoLoad(this.tArea, this.isRoot);
      });
    }
    else if(this.pageData.ActionMode == 'EDIT'){
      this.svcData.sensorUpdate(_arg).subscribe(res=>{
        if(res.status != 'OK'){
          this.showAlert(res.message);
          return;
        }
        this.showAlert('Sensor information is updated!');
        this.pageData.viewMode = 'LIST';
        this.areaInfoLoad(this.tArea, this.isRoot);
      });
    }
  }
  sensorFormValidate(){
    if(!this.pageData.sensorId){
      this.showAlert('Sensor ID should not be empty!');
      return false;
    }
    if(!this.pageData.sensorName){
      this.showAlert('Sensor Name should not be empty!');
      return false;
    }
    if(this.pageData.sensorInFlow == -1){
      this.showAlert('Please define the Sensor In Flow!');
      return false;
    }
    if(this.pageData.sensorOutFlow == -1){
      this.showAlert('Please define the Sensor Out Flow!');
      return false;
    }

    return true;
  }
  sensorRemove(){
    if(!confirm(`Are you sure you want to delete the sensor "${this.sensorSelected.sensorName}" from "${this.tArea.areaName}"?`)) return;
    
    this.svcData.sensorRemove(this.sensorSelected).subscribe(res=>{
      if(res.status != 'OK'){
        this.showAlert(res.message);
        return;
      }
      this.pageData.viewMode = 'LIST';
      this.areaInfoLoad(this.tArea, this.isRoot);
    });
  }

  showAlert(msg){
    //alert(msg);
    M.toast({html: msg});
  }
  locationSetUpForm(){
    this.goto('/location-setup/'+this.tArea.areaId);
  }
  goto = function(argRout){
    this.router.navigate([argRout]);
  }

  prioritySelectDdl(evt: any){
    //console.log(evt);
    if(evt != '-- Select Priority --'){
      this.svcData.configAdd(this.tArea.areaId, 'area.priority', evt).subscribe(res=>{
        if(res.status != 'OK'){
          this.showAlert(res.message);
          return;
        }
        this.showAlert('Priority config is updated!');
        this.areaInfoLoad(this.tArea, this.isRoot);
      });
    }
  }

  // photoSelectFile(event) { 
  //   var _file = event.target.files[0]; 
  //   var _self = this; 
 
  //   this.getBase64(_file, function (res) { 
  //     var _imgData = { 
  //       imgDataUrl: res, 
  //       base64: res.replace(/^data:(.*;base64,)?/, '') 
  //     }
  //   });
  // }

  getBase64(file, funCallback) { 
    var reader = new FileReader(); 
    reader.readAsDataURL(file); 
    reader.onload = () => { 
      funCallback(reader.result); 
    }; 
    reader.onerror = (error) => { 
      this.showAlert('ERROR'); 
    }; 
  }

  getFPImage(argArea: any){
    this.svcData.getFPImage(argArea).subscribe(res => {
      //console.log(res);
      this.imgPath = 'data:image/png;base64,'+res.data;
    })
  }

}
